var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 66.288 66.288"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "play_circle_svg__a",
    x: 0,
    y: 0,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 251"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#play_circle_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 54",
    cx: 24.144,
    cy: 24.144,
    r: 24.144,
    transform: "translate(9 6)",
    fill: "#8155a2"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Polygon 4",
    d: "M42.767 27.524a3 3 0 010 5.24l-12.12 6.759a3 3 0 01-4.461-2.62V23.385a3 3 0 014.461-2.62z",
    fill: "#fff",
    opacity: 0.97
  }))));
}
export default SvgPlayCircle;